export default __webpack_public_path__ + "static/media/document_filled.0551eb66.svg";